import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TenantService } from '../services/tenant.service';
import { isBackendApiRequest } from './helper.utils';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  private tenantService = inject(TenantService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!isBackendApiRequest(req.url)) {
      return next.handle(req);
    }

    const slug = this.tenantService.getTenantSlug();
    const tenantId = this.tenantService.getTenantId();

    let headers = req.headers;
    if (slug) {
      headers = headers.set('X-Tenant-Slug', slug);
    }
    if (tenantId) {
      headers = headers.set('X-Tenant-ID', tenantId);
    }

    const clonedReq = req.clone({ headers });
    return next.handle(clonedReq);
  }
}
